<template>
  <div class="nav2Box z1200">
    <div class="top_set">
      <a href="user?index=0">通行证首页</a>
      <span> >充值中心</span>
    </div>
    <div class="payContent">
      <div class="tips">
        充值中心
      </div>
      <div class="list_ul">
        <div v-for="(item,index) in dataList" :key="index" class="paylist" @click="handelIndex(item,index)">
          <img :src="payImg[index]" alt="" :class="currentIdnex==index?'avtiveImg':'noImg'">
          <p class="paymsg">
            <span>￥</span>
            <span class="paynum">{{ item.COMMODITY_AMOUNT/100 }}</span>
            <span>元</span>
          </p>
          <span v-show="currentIdnex==index" class="checkedone" />
        </div>
      </div>
      <div class="btn_pay">
        <span @click="gopay">确认充值</span>
      </div>
    </div>
    <div v-show="ispayState" class="shaDowPay">
      <div id="qrcode_pay">
        <div class="shaDowPayhead">
          <span style="margin-left: 23px;font-size: 14px;color: #666;">微信扫码支付</span>
          <span style="float: right;margin-right: 15px;font-size: 20px;color:#999;cursor: pointer" @click="handelClose">X</span>
        </div>
        <img :src="logo" alt="" style="position: absolute;width: 85px; height: 85px;top: 236px;left: 192px;border-radius: 5px">
        <div id="qrcode_pay_box" ref="qrcode_pay_box" />
      </div>
    </div>
  </div>
</template>
<script>
import { loadIndex, getPayCommodityList, startPayRecharge, verificationOrder } from '@/api/api.js'
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      timer: null,
      ispayState: false,
      logo: require('@/static/wxPay.png'),
      currentItem: {},
      currentIdnex: 0,
      passportid: '',
      dataList: [],
      payImg: [
        require('@/static/pay1.png'), require('@/static/pay2.png'), require('@/static/pay3.png'), require('@/static/pay3.png')
      ]
    }
    // /初始化数据
  },
  mounted() {
    this.fetchData()
    // this.imgCutUploadParams.param.userId = this.getLoca('userid')
    // console.log(dataJson)
    // this.countryData = dataJson.dataJson
  },
  methods: {
    fetchData() {
      getPayCommodityList().then(res => {
        this.dataList = res.data
        for (var i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].IS_RECOMMEND == 1) {
            this.currentItem = res.data[i]
            this.currentIdnex = i
          }
        }
      })
      if (this.getLoca('passportid')) {
      } else {
        loadIndex().then(res => {
          this.passportid = res.data.passportUser.passportid
          this.setloca('passportid', res.data.passportUser.passportid, 7200)
        })
      }
    },
    handelIndex(item, index) {
      this.currentIdnex = index
      this.currentItem = item
    },
    gopay() {
      startPayRecharge({ commodityId: this.currentItem.COMMODITY_ID }).then(res => {
        this.ispayState = true
        this.getCode(res.data.url)
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.checkPay(res.data.orderid)
        this.timer = setInterval(() => {
          this.checkPay(res.data.orderid)
        }, 60000)
      })
    },
    getCode(url) {
      const qrcodepay = new QRCode('qrcode_pay_box', {
        text: url,
        width: 330,
        height: 330,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcodepay.clear()
      qrcodepay.makeCode(url)// 生成另一个新的二维码
    },
    handelClose() {
      this.ispayState = false
      this.$refs.qrcode_pay_box.innerHTML = ''
    },
    checkPay(orderid) {
      verificationOrder({ orderid: orderid }).then(res2 => {
        if (res2.data) {
          this.ispayState = false
          this.$refs.qrcode_pay_box.innerHTML = ''
          this.$message({
            type: 'success',
            message: '支付成功'
          })
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  #qrcode_pay_box{
    width: 330px;
    height: 330px;
  }
    .z1200{
        width: 1200px;
        margin: 0 auto;
    }
    .nav2Box{
        overflow: hidden;
        min-height: 100vh;
        .top_set{
            height: 80px;
            line-height: 80px;
            text-align: left;
            font-size: 14px;
            a{
                color: #999999;
            }
            span{
                color: #666666;
            }
        }
      .payContent{
        background-color: #fff;
        min-height: 530px;
        padding: 0 30px;
        .tips{
          display: inline-block;
          padding-left: 7px;
          border-left: 3px solid #E0466E;
          height: 17px;
          line-height: 17px;
          margin-top: 30px;
          font-size: 18px;
        }
        .list_ul{
          margin-top: 55px;
          overflow: hidden;
        }
        .paylist{
          width: 260px;
          height: 160px;
          display: inline-block;
          vertical-align: top;
          position: relative;
          margin-right: 20px;
          cursor: pointer;
          img{
            width: 260px;
            height: 160px;
          }
          .avtiveImg{
            border: 2px solid #E0466E;
            width: 256px;
            height: 156px;
            border-radius: 6px;
          }
          .paymsg{
            position: absolute;
            top: 66px;
            left: 0;
            width: 270px;
            text-align: center;
            span{
              font-size: 14px;
              color: #ffffff;
            }
            .paynum{
              font-size: 36px;
            }
          }
          .checkedone{
            display: inline-block;
            position: absolute;
            bottom: -18px;
            right: -3px;
            width: 0;
            height: 0;
            border-left: 30px solid #E0466E;
            border-top: 30px solid transparent;
            border-bottom: 30px solid transparent;
            transform: rotate(45deg);
          }
        }
        .paylist:nth-child(4n){
          margin-right: 0;
        }
        .btn_pay{
          margin-top: 130px;
          text-align: center;
          span{
            display: inline-block;
            width: 100px;
            height: 38px;
            line-height: 38px;
            background-color: #E0466E;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
    }
    .shaDowPay{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      text-align: center;
      #qrcode_pay{
        position: relative;
        display: inline-block;
        width: 330px;
        background-color: #fff;
        padding: 0 70px;
        padding-bottom: 70px;
        top: 200px;
      }
      .shaDowPayhead{
        height: 53px;
        line-height: 53px;
        background-color: #fff;
        border-bottom: 1px solid #E1E8F1;
        display: inline-block;
        width: 470px;
        position: relative;
        left: -70px;
        text-align: left;
        margin-bottom: 60px;
      }
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {

    }
</style>

